export default __webpack_public_path__ + "static/safe-713400e6b7a9e1ed79f2d47909342f9e.jpg";